import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import { fromEvent, take } from 'rxjs';

import { MatchMediaService } from '@media/services/match-media.service';
import { SavedSearchStoreService } from '@saved-search/store/services/saved-search-store.service';
import { SearchStoreService } from '@search/store/services/search-store.service';
import { RpcButtonComponent } from '../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { SavedSearchInfoComponent } from '../saved-search-info/saved-search-info.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'saved-search-list',
    templateUrl: './saved-search-list.component.html',
    styleUrls: ['./saved-search-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcButtonComponent, SavedSearchInfoComponent, AsyncPipe, TranslateModule]
})
export class SavedSearchListComponent implements AfterViewInit {

    @Output() public createSavedSearch = new EventEmitter<void>();
    @Output() public closed = new EventEmitter<void>();

    public readonly activeSavedSearchId$ = this.savedSearchStoreService.activeSavedSearchId$;
    public readonly savedSearchesInfo$ = this.savedSearchStoreService.savedSearchesInfo$;
    public readonly isCriteriaEmpty$ = this.searchStoreService.isCriteriaEmpty$;

    constructor(
        private readonly savedSearchStoreService: SavedSearchStoreService,
        private readonly searchStoreService: SearchStoreService,
        private readonly matchMediaService: MatchMediaService,
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef<HTMLElement>,
    ) { }

    public ngAfterViewInit(): void {
        const panelElement = this.elementRef.nativeElement.parentElement;

        this.renderer.setStyle(panelElement, 'height', panelElement.clientHeight + 'px');

        if (this.matchMediaService.activeMediaQuery === 'xs') {
            fromEvent(panelElement, 'scroll')
                .pipe(take(1))
                .subscribe(() => this.onExpandPanel());
        }
    }

    public onSavedSearchSelected(activeSavedSearchId: number): void {
        this.savedSearchStoreService.runSavedSearch(activeSavedSearchId);

        this.onClose();
    }

    public onEditSavedSearch(activeSavedSearchId: number): void {
        this.savedSearchStoreService.showAddEditSavedSearchDialog(activeSavedSearchId);

        this.onClose();
    }

    public onCreateNewSavedSearch(): void {
        this.savedSearchStoreService.showSaveYourSearch();

        this.onClose();
    }

    public onClose(): void {
        this.closed.emit();
    }

    public onExpandPanel(): void {
        if (this.matchMediaService.activeMediaQuery === 'xs') {
            this.renderer.addClass(this.elementRef.nativeElement.parentElement, 'rpc-bottomsheet--top');

            this.renderer.removeStyle(this.elementRef.nativeElement.parentElement, 'height');
        }
    }
}